/**
 * @generated SignedSource<<aa39da31e4994eb75b410245cec820d2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateTasksBulkInput = {
  tasks?: ReadonlyArray<TaskBulk | null> | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type TaskBulk = {
  taskId?: string | null;
  roleId?: string | null;
  estimateLow?: number | null;
  estimateHigh?: number | null;
  estimateForecast?: number | null;
  personIds?: ReadonlyArray<string | null> | null;
  labelIds?: ReadonlyArray<string | null> | null;
};
export type updateTasksBulkSchedulingMutation$variables = {
  input: UpdateTasksBulkInput;
};
export type updateTasksBulkSchedulingMutation$data = {
  readonly updateTasksBulk: {
    readonly tasks: ReadonlyArray<{
      readonly assignedPersons: ReadonlyArray<{
        readonly id: string;
        readonly firstName: string | null;
        readonly lastName: string | null;
        readonly profilePictureId: string | null;
      } | null> | null;
      readonly billable: boolean | null;
      readonly blocked: boolean | null;
      readonly bug: boolean | null;
      readonly companyTaskId: number | null;
      readonly deadlineDay: number | null;
      readonly deadlineMonth: number | null;
      readonly deadlineYear: number | null;
      readonly deadlineFrom: string | null;
      readonly startFrom: string | null;
      readonly done: boolean | null;
      readonly estimateForecast: number | null;
      readonly estimateForecastMinutes: number | null;
      readonly highPriority: boolean | null;
      readonly estimateForecastPrice: number | null;
      readonly id: string;
      readonly role: {
        readonly id: string;
      } | null;
      readonly phase: {
        readonly id: string;
      } | null;
      readonly statusColumnV2: {
        readonly id: string;
      } | null;
      readonly progress: number | null;
      readonly startDay: number | null;
      readonly startMonth: number | null;
      readonly startYear: number | null;
      readonly timeLeft: number | null;
      readonly name: string | null;
      readonly project: {
        readonly id: string;
        readonly completion: number | null;
        readonly remaining: number | null;
        readonly forecast: number | null;
      } | null;
    } | null> | null;
  } | null;
};
export type updateTasksBulkSchedulingMutation = {
  variables: updateTasksBulkSchedulingMutation$variables;
  response: updateTasksBulkSchedulingMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  (v1/*: any*/)
],
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateTasksBulkPayload",
    "kind": "LinkedField",
    "name": "updateTasksBulk",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Task",
        "kind": "LinkedField",
        "name": "tasks",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Person",
            "kind": "LinkedField",
            "name": "assignedPersons",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "profilePictureId",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "billable",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "blocked",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bug",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "companyTaskId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "deadlineDay",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "deadlineMonth",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "deadlineYear",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "deadlineFrom",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "startFrom",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "done",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "estimateForecast",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "estimateForecastMinutes",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "highPriority",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "estimateForecastPrice",
            "storageKey": null
          },
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Role",
            "kind": "LinkedField",
            "name": "role",
            "plural": false,
            "selections": (v2/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PhaseType",
            "kind": "LinkedField",
            "name": "phase",
            "plural": false,
            "selections": (v2/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "StatusColumnV2",
            "kind": "LinkedField",
            "name": "statusColumnV2",
            "plural": false,
            "selections": (v2/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "progress",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "startDay",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "startMonth",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "startYear",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timeLeft",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "completion",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "remaining",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "forecast",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateTasksBulkSchedulingMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateTasksBulkSchedulingMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "122befecd6353eac060449336a0b92f0",
    "id": null,
    "metadata": {},
    "name": "updateTasksBulkSchedulingMutation",
    "operationKind": "mutation",
    "text": "mutation updateTasksBulkSchedulingMutation(\n  $input: UpdateTasksBulkInput!\n) {\n  updateTasksBulk(input: $input) {\n    tasks {\n      assignedPersons {\n        id\n        firstName\n        lastName\n        profilePictureId\n      }\n      billable\n      blocked\n      bug\n      companyTaskId\n      deadlineDay\n      deadlineMonth\n      deadlineYear\n      deadlineFrom\n      startFrom\n      done\n      estimateForecast\n      estimateForecastMinutes\n      highPriority\n      estimateForecastPrice\n      id\n      role {\n        id\n      }\n      phase {\n        id\n      }\n      statusColumnV2 {\n        id\n      }\n      progress\n      startDay\n      startMonth\n      startYear\n      timeLeft\n      name\n      project {\n        id\n        completion\n        remaining\n        forecast\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1ec46e5cde4f71921d03670a2ccdf9b9";

export default node;
